import type { Nullable } from 'corgi-types';

import { inputIsMatching } from '../components/DynamicForm/utils/regex-helpers';
import { StateType } from '../enums/StateType';
import type { PasswordHelpMessagesConfigFragment } from '../gql/generated/schema';
import type { ExcludeEmpty } from '../types/utils';

type PasswordHelpMessagesConfig = ExcludeEmpty<PasswordHelpMessagesConfigFragment>;

const isPasswordHelpMessagesConfig = (
  config: PasswordHelpMessagesConfigFragment
): config is PasswordHelpMessagesConfig => 'regex' in config;

export const getPasswordFieldHelpMessages = ({
  value,
  helpMessagesConfig = null,
}: {
  value: string;
  helpMessagesConfig: Nullable<PasswordHelpMessagesConfigFragment[]>;
}) => {
  if (!helpMessagesConfig) {
    return [];
  }

  return helpMessagesConfig
    .filter(isPasswordHelpMessagesConfig)
    .map(({ regex, message }) =>
      !value
        ? { message, type: StateType.Info }
        : !inputIsMatching(regex, value)
          ? { message, type: StateType.Error }
          : { message, type: StateType.Success }
    );
};
